/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type OwnerApiResourceType = typeof OwnerApiResourceType[keyof typeof OwnerApiResourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OwnerApiResourceType = {
  owner: 'owner',
} as const;
